import { FC, useMemo } from 'react'

import { useSelector } from 'react-redux'
import { Elements } from '@stripe/react-stripe-js'

import { getStripePromise } from 'src/Services/stripeClient'
import { getResolvedTheme } from 'src/Redux/theme-process'

import {
  WalletExpressCheckoutForm,
  WalletExpressCheckoutFormProps,
} from './WalletExpressCheckoutForm'
import { WALLET_BUTTON_BORDER_RADIUS } from './walletButtonAppearance'

const CENTS_IN_DOLLAR = 100

export interface WalletExpressCheckoutProps extends WalletExpressCheckoutFormProps {
  amount: number
}

export const WalletExpressCheckout: FC<WalletExpressCheckoutProps> = ({
  amount,
  ...formProps
}) => {
  const stripe = useMemo(() => getStripePromise(), [])
  const resolvedTheme = useSelector(getResolvedTheme)

  if (amount <= 0) {
    return null
  }

  return (
    <Elements
      stripe={stripe}
      options={{
        mode: 'payment',
        amount: Math.round(amount * CENTS_IN_DOLLAR),
        currency: 'usd',
        appearance: {
          variables: { borderRadius: WALLET_BUTTON_BORDER_RADIUS },
        },
      }}
    >
      <WalletExpressCheckoutForm resolvedTheme={resolvedTheme} {...formProps} />
    </Elements>
  )
}
